import './PortProductCertificates.css'
import 'antd/dist/reset.css'
import React from 'react'
import Certificates2 from '../../../images/certificate/certificates_2.jpeg'

export default class PortQualityCertificates extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="PortProductCertificates">
        <img className="PortProductCertificatesImage" src={Certificates2} />
        <div className="PortProductCertificatesText">
          <div className="PortProductCertificatesName">
            环境管理体系认证证书
          </div>
          <div className="PortProductCertificatesContent">
            环境管理体系认证证书是第三方机构对企业环境管理体系符合国际标准（如ISO
            14001）的正式认可证明。它表明企业已建立系统化的环境管理机制，能够有效控制污染、节约资源、降低环境风险，并持续改进环境绩效。
          </div>
        </div>
      </div>
    )
  }
}
